import { render, staticRenderFns } from "./showMath.vue?vue&type=template&id=144d0c89&scoped=true&"
import script from "./showMath.vue?vue&type=script&lang=js&"
export * from "./showMath.vue?vue&type=script&lang=js&"
import style0 from "./showMath.vue?vue&type=style&index=0&id=144d0c89&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d0c89",
  null
  
)

/* custom blocks */
import block0 from "./showMath.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Fcdn.jsdelivr.net%2Fnpm%2Fkatex%400.16.9%2Fdist%2Fkatex.min.css"
if (typeof block0 === 'function') block0(component)

export default component.exports